import * as React from "react";

import type { ActivityContentProjectClosed } from "@/api";
import type { Activity } from "@/models/activities";
import type { ActivityHandler, FeedItemProps } from "../interfaces";

import { Link } from "turboui";
import { Trans } from "../i18n";
import i18n from "@/i18n";
import { activityAuthorName, projectLink } from "../feedItemLinks";

const ProjectClosed: ActivityHandler = {
  pageHtmlTitle(_activity: Activity) {
    throw new Error("Not implemented");
  },

  pagePath(paths, activity: Activity): string {
    return paths.projectRetrospectivePath(content(activity).project!.id!);
  },

  PageTitle(_props: { activity: any }) {
    throw new Error("Not implemented");
  },

  PageContent(_props: { activity: Activity }) {
    throw new Error("Not implemented");
  },

  PageOptions(_props: { activity: Activity }) {
    return null;
  },

  FeedItemTitle({ activity, page, paths }: FeedItemProps) {
    const retroId = content(activity).project!.id!;
    const retroPath = paths.projectRetrospectivePath(retroId!);
    const retroLink = <Link to={retroPath}>{null}</Link>;
    const project = projectLink(paths, content(activity).project!);

    if (page === "project") {
      return (
        <Trans
          i18nKey="{{author}} closed the project and submitted a <retrospective>retrospective</retrospective>"
          values={{ author: activityAuthorName(activity) }}
          components={{ retrospective: retroLink }}
        />
      );
    } else {
      return (
        <Trans
          i18nKey="{{author}} closed the <project>{{projectName}}</project> project and submitted a <retrospective>retrospective</retrospective>"
          values={{ author: activityAuthorName(activity), projectName: content(activity).project?.name }}
          components={{ retrospective: retroLink, project }}
        />
      );
    }
  },

  FeedItemContent(_props: { activity: Activity; page: any }) {
    return null;
  },

  feedItemAlignment(_activity: Activity): "items-start" | "items-center" {
    return "items-center";
  },

  commentCount(_activity: Activity): number {
    throw new Error("Not implemented");
  },

  hasComments(_activity: Activity): boolean {
    throw new Error("Not implemented");
  },

  NotificationTitle(_props: { activity: Activity }) {
    return i18n.t("Closed this project and submitted a retrospective");
  },

  NotificationLocation({ activity }: { activity: Activity }) {
    return content(activity).project!.name!;
  },
};

function content(activity: Activity): ActivityContentProjectClosed {
  return activity.content as ActivityContentProjectClosed;
}

export default ProjectClosed;
